import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee81d586"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "checkbox-group"
}
const _hoisted_2 = {
  key: 1,
  class: "help is-danger"
}

import { computed, watch } from 'vue'
import { isEmpty } from 'lodash'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import {
  CheckboxOption,
  CheckboxSettings,
  FieldDefinition,
  FieldType,
  RequestFieldValue,
  TextSettings
} from '../types/request_fields'

type TypedProps =
  | {
      field_type: FieldType.Text // eslint-disable-line camelcase
      type_settings: TextSettings // eslint-disable-line camelcase
      modelValue: string
    }
  | {
      field_type: FieldType.Checkbox // eslint-disable-line camelcase
      type_settings: CheckboxSettings // eslint-disable-line camelcase
      modelValue: CheckboxOption[]
    }


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestFieldInput',
  props: {
    definition: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "on-validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// This combines the definition and modelValue into one type so that code can know the type of the `modelValue` depending on the `field_type`.
const typedProps = computed<TypedProps>(() => {
  let value = props.modelValue

  switch (props.definition.field_type) {
    case FieldType.Text:
      value = value || ''
      if (typeof value !== 'string') {
        throw new Error('Unexpected type')
      }
      return {
        field_type: props.definition.field_type,
        modelValue: value || '',
        type_settings: props.definition.type_settings
      }
    case FieldType.Checkbox:
      value = value || []
      if (!Array.isArray(value)) {
        throw new Error('Unexpected type')
      }
      return {
        field_type: props.definition.field_type,
        modelValue: value,
        type_settings: props.definition.type_settings
      }
    default:
      throw new Error('Unexpected field type')
  }
})

const noLabel = computed(
  () =>
    props.definition.type_settings.hideLabel ||
    isEmpty(props.definition.type_settings.labelText)
)

const isChecked = (
  option: CheckboxOption,
  currentlyChecked: CheckboxOption[]
) => {
  return currentlyChecked.some((checked) => checked.uuid === option.uuid)
}

const checkOption = (
  option: CheckboxOption,
  checked: boolean,
  currentlyChecked: CheckboxOption[]
) => {
  const alreadyChecked = isChecked(option, currentlyChecked)
  if (alreadyChecked && !checked) {
    const selectedOptions: CheckboxOption[] = currentlyChecked.filter(
      (other: CheckboxOption) => other.uuid !== option.uuid
    )
    emit('update:modelValue', selectedOptions)
  } else if (!alreadyChecked && checked) {
    const selectedOptions: CheckboxOption[] = [
      option,
      ...(currentlyChecked || [])
    ]
    emit('update:modelValue', selectedOptions)
  }
}
const isCheckboxValid = computed(() => {
  return (
    !typedProps.value.type_settings.isMandatory ||
    (typedProps.value.modelValue && typedProps.value.modelValue.length > 0)
  )
})

watch(
  isCheckboxValid,
  (val) => {
    if (typedProps.value.field_type === 'checkbox') {
      emit('on-validate', props.definition.id, val)
    }
  },
  { immediate: true }
)

const handleFormInputValidation = (isValid: boolean) => {
  emit('on-validate', props.definition.id, isValid)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (typedProps.value.field_type === _unref(FieldType).Text)
      ? (_openBlock(), _createBlock(NrFormInput, {
          key: 0,
          type: "text",
          modelValue: typedProps.value.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = 
      (fieldValue) => emit('update:modelValue', fieldValue)
    ),
          tag: typedProps.value.type_settings.isTextArea ? 'textarea' : 'input',
          label: typedProps.value.type_settings.labelText,
          hideLabel: noLabel.value,
          class: _normalizeClass(noLabel.value ? 'request-field-no-label' : null),
          placeholder: typedProps.value.type_settings.placeholderText,
          help: typedProps.value.type_settings.helperText,
          required: typedProps.value.type_settings.isMandatory,
          maxLength: typedProps.value.type_settings.characterLimitMax?.toString(),
          minLength: typedProps.value.type_settings.characterLimitMin?.toString(),
          withTooltip: !_unref(isEmpty)(typedProps.value.type_settings.tooltipText),
          iconTooltipText: typedProps.value.type_settings.tooltipText,
          onOnValidate: handleFormInputValidation
        }, null, 8, ["modelValue", "tag", "label", "hideLabel", "class", "placeholder", "help", "required", "maxLength", "minLength", "withTooltip", "iconTooltipText"]))
      : _createCommentVNode("", true),
    (typedProps.value.field_type === _unref(FieldType).Checkbox)
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
          (typedProps.value.type_settings.labelText)
            ? (_openBlock(), _createElementBlock("legend", {
                key: 0,
                class: _normalizeClass(noLabel.value ? 'is-sr-only' : 'checkbox-header')
              }, _toDisplayString(typedProps.value.type_settings.labelText) + " " + _toDisplayString(typedProps.value.type_settings.isMandatory ? '*' : ''), 3))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typedProps.value.type_settings.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              key: option.uuid,
              class: "checkbox-item"
            }, [
              _createVNode(NrFormInput, {
                type: "checkbox",
                label: option.name,
                modelValue: isChecked(option, typedProps.value.modelValue),
                "onUpdate:modelValue": 
          (checked) =>
            checkOption(option, checked, typedProps.value.modelValue)
        
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128)),
          (!isCheckboxValid.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, " At least one option must be selected. "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})